import React, { useEffect } from 'react'
import Control from '../store/control';
import Param from '../store/param';

// Ischial level
const FormAlign_1 = () => {
  const SetCameraOut  = Control.Get('SetCameraOut');
  const setup         = Param.Get('setup');

  useEffect(() => {
    SetCameraOut(0, 0); // first augment is side of the leg and alwais is zero for AK.
  }, []);

  return null;
}
export default FormAlign_1;
